import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=5c4e3f78&scoped=true&"
import script from "./no-content.vue?vue&type=script&lang=js&"
export * from "./no-content.vue?vue&type=script&lang=js&"
import style0 from "./no-content.vue?vue&type=style&index=0&id=5c4e3f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e3f78",
  null
  
)

export default component.exports